import React, { createElement } from 'react';
import Player from '@ifeng-fe/three_terminal/es/pc/video/output/pcVideo.jsx';
import md5 from 'md5';
import { formatImage } from '@ifeng-fe/public_method'

export interface Video_1_Props {
    nodeId?: string
    style?: object; // 通用样式

    title: string; // 视频标题
    posterUrl: string; // 视频缩略图
    videoPlayUrl: string; // 视频链接

    width: number; // 播放器宽
    height: number; // 播放器高
    autoPlay: boolean; // 是否自动播放
    controls: boolean; // 是否显示播放控件
}

const Video_1: React.FC<Video_1_Props> = (props) => {
    const { nodeId, style, title, posterUrl, videoPlayUrl, width, height, autoPlay, controls } = props;

    const getHash = () => {
        return md5(JSON.stringify(props));
    };

    return (
        <div id={nodeId} style={style}>
            <Player
                key={getHash()}
                videoConfig={{ title, posterUrl: formatImage(posterUrl, width, height), videoPlayUrl }}
                playermsg={{ width, height, autoPlay, controls }}
            />
        </div>
    );
};

export default Video_1;
